import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import {
  CardElement
} from '@stripe/react-stripe-js';

import {
  purchase
} from 'shared/actions/cartActions';

const styles = theme => ({
  cardElement: {
    display: 'inline-block',
    width: '100%',
    height: '3.28rem',
    padding: '1rem',
    marginBottom: '0',
    border: '1px solid #aaa',
    borderRadius: '5px',
    error: null
  },
  error: {
    display: 'inline-block',
    float: 'left',
    width: '100%',
    textAlign: 'left',
    color: 'red',
    marginBottom: '0.2rem'
  }
});

class PaymentForm extends React.Component {
  constructor(props) {
    super(props);

    this.options = {
      disableLink: true,
      style: {
        base: {
          fontSize: '1.1rem',
        },
        invalid: {
          color: 'red'
        }
      }
    }

    this.submitting = false;

    this.state = {
      error: null
    }
  }

  componentWillUpdate() {
    const button = this.props.button.current;
    if (button) {
      this.buttonText = this.buttonText || button.innerText;
      button.onclick = this.submit.bind(this);
    }
  }

  onChange(event) {
    if (event.error) {
      this.setError(event.error.message);
    } else {
      this.clearError();
    }
  }

  async submit(event) {
    if (this.submitting) {
      return;
    }

    if (this.props.confirmCallback) {
      const proceed = await this.props.confirmCallback();
      if (!proceed) {
        return;
      }
    }

    this.submitting = true;

    const { stripe, elements } = this.props;
    if (!stripe || !elements) {
      return;
    }

    event.preventDefault();

    const email = this.props.email.current;
    const name = this.props.name.current;

    this.showPurchasing();
    this.clearError();

    try {
      const { stripe, elements, purchaseRequestId, freeMode, requiredName } = this.props;

      if (requiredName && !name?.value) {
        throw { error: "Please enter a customer name." }
      }

      if (!email.dummy) {
        if (!email.value || !email.value.match(/@/)) {
          email.style.borderColor = 'red';
          email.onchange = function () {
            this.style.borderColor = '#aaa';
          }
          throw { error: "Please enter a valid email address" }
        } else {
          email.style.borderColor = '#aaa';
        }
      }

      let paymentMethodId = null;
      if (!freeMode) {
        const cardElement = elements.getElement(CardElement);
        const { paymentMethod, error } = await stripe.createPaymentMethod({
          type: 'card',
          card: cardElement
        });

        if (error) {
          this.clearPurchasing();
          throw { error: error.message }
        }

        paymentMethodId = paymentMethod.id;
      }

      let params = {
        purchase_request_id: purchaseRequestId,
        payment_method_id: paymentMethodId,
        moment_ids: this.props.selectedMomentIds,
        print_moment_ids: this.props.selectedPrintMomentIds,
        email: this.props.email.current.value,
        customer_name: this.props.name.current?.value,
        account_id: this.props.accountId,
        kiosk_token: this.props.kioskToken,
        story_id: this.props.storyId,
        coupon_code: this.props.discountCode,
        description: this.props.description
      }

      let purchase = await this.props.purchase(params);

      if (purchase.requires_action) {
        let { paymentIntent, error } = await stripe.handleCardAction(purchase.payment_intent_client_secret);

        if (error) {
          this.clearPurchasing();
          this.setError(error);
          return;
        }

        params.payment_method_id = null;
        params.payment_intent_id = paymentIntent.id;

        purchase = await this.props.purchase(params);
      }

      this.clearPurchasing();
      this.props.callback(purchase);

    } catch (err) {
      this.clearPurchasing();
      this.submitting = false;

      if (err.error) {
        this.setError(err);
      } else {
        console.error(err);

        this.setError("Sorry, we experienced a problem processing this charge. Please try again and contact us if the problem persists.");
      }
    }
  }

  showPurchasing() {
    if (this.props.button.current) {
      this.props.button.current.innerText = this.props.processingText;
    }
  }

  clearPurchasing() {
    if (this.props.button.current) {
      this.props.button.current.innerText = this.buttonText;
    }
  }

  clearError() {
    this.setState({ error: null });
  }

  setError(err) {
    console.error(err);

    if (typeof err === 'string') {
      this.setState({ error: err });
    } else {
      this.setState({ error: err.error });
    }
  }

  render() {
    const { classes, errorStyle, freeMode, selectedMomentIds, } = this.props;

    let error = null;
    if (this.state.error) {
      error = (
        <span className={classes.error} style={errorStyle}>{this.state.error}</span>
      );
    }

    let form;
    if (freeMode) {
      let msgStyle = {
        marginTop: '1.75rem',
        fontWeight: 600
      }

      let msg;
      if (selectedMomentIds.length === 1) {
        msg = 'This image will be provided free of charge.';
      } else {
        msg = 'These images will be provided free of charge.';
      }

      form = <p style={msgStyle}>{msg}</p>;

    } else {
      form = (
        <div className={classes.cardElement}>
          <CardElement options={this.options} />
        </div>
      );
    }

    return (
      <div>
        {form}
        {error}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedMomentIds: state.cartReducer.selectedMomentIds,
  selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds
});

export default connect(mapStateToProps, { purchase })(withStyles(styles, { withTheme: true })(PaymentForm));
